<style lang="scss" scoped>
  .chatting-block {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 10px;
    padding: 40px 34px 60px;
    background: linear-gradient(0deg, #000000 -1.37%, rgba(0, 0, 0, 0) 90.64%), #292E34;

    @include media(max, lg) {
      padding: 0 60px;
      background: none;
    }

    @include media(max, lg) {
      padding: 0;
    }

    .chatting-list {
      margin-top: 40px;
      display: flex;
      width: 100%;
      max-width: 910px;
     justify-content: space-between;

      @include media(max, lg) {
        margin-top: 20px;
        flex-direction: column;
      }

      @include media(max, md) {
        display: block;
        padding: 0;
      }

      .list-item {
        max-width: 280px;
        text-align: center;

        @include media(max, lg) {
          display: flex;
          max-width: none;
          margin-bottom: 10px;
          &:last-child .item-info {
              border-bottom: 0;
          }
        }

        .item-icon {
          position: relative;
          font-size: 80px;
          height: 80px;
          @include media(max, lg) {
            flex: none;
            font-size: 60px;
            height: 60px;
            margin: 0 20px;
            &.PROCHAINEMENT {
              margin: 0 50px;
            }
          }
        }

        .item-icon_svg {
          width: 1em;
          height: 1em;
          line-height: 1em;
          background: 50% 50%/cover no-repeat;
          margin: 0 auto;
        }

        .item-info {
          margin-top: 18px;

          @include media(max, lg) {
            flex: 1;
            text-align: left;
            margin-top: 0;
            padding: 14px 0;
            border-bottom: 1px solid #32383E;

            [dir=rtl] & {
              text-align: right;
            }
          }

          .info-title {
            font-size: 28px;
            font-weight: 500;
            line-height: normal;
            color: #F5F5F7;;

            @include media(max, lg) {
              font-size: 22px;
              line-height: 20px;
            }
          }

          .info-description {
            margin-top: 10px;
            font-size: 18px;
            line-height: 1.6;
            color: rgba(white, .76);

            @include media(max, lg) {
              font-size: 16px;
            }
          }
        }
      }
    }

    .hooper {
      height: 300px;

      ::v-deep .hooper-indicator {
        width: 30px;
        height: 2px;
        border-radius: 2px;
        background-color: rgba(#d4d4d4, .24);

        &.is-active {
          background-color: rgba(white, .54);
        }
      }
    }
  }
</style>

<template>
  <div class="chatting-block" id="chatting-block">
    <div class="title_section">{{$t('title')}}</div>
    <div class="chatting-list">

      <component
        v-for="(block, index) in $t('blocks')"
        :key="index"
        :is="'div'"
        class="list-item">
        <div class="item-icon">
          <div class="item-icon_svg"
               :style="{backgroundImage: `url(${baseUrl}images/svg/${block.icon}.svg)`}"></div>
        </div>
        <div class="item-info">
          <div class="info-title" v-html="block.title"></div>
          <div class="info-description" v-html="block.description"></div>
        </div>
      </component>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ChattingBlock',
  i18n: {
    messages: {
      ru: {
        title: 'Общайтесь',
        blocks: [
          {
            icon: 'smile',
            title: 'Находите друзей',
            description: 'Знакомьтесь с новыми людьми и играйте вместе',
            type: 'dating',
          },
          {
            icon: 'speech-bubble',
            title: 'Создавайте чаты',
            description: 'Присоединяйтесь к чатам и формируйте новые',
            type: 'chat',
          },
          {
            icon: 'people',
            title: 'Следите <br class="br-none">за новостями',
            description: 'Узнавайте новости друзей, делитесь мнениями, секретами и&nbsp;победами в&nbsp;сообществе',
            link: {
              title: 'Перейти',
            },
            type: 'community',
          },
        ],
      },
      en: {
        title: 'Communicate',
        blocks: [
          {
            icon: 'smile',
            title: 'Find Friends',
            description: 'Meet new people and play together',
          },
          {
            icon: 'speech-bubble',
            title: 'Create Chats',
            description: 'Make sure your squad is in sync. Easily create or join chats with friends!',
          },
          {
            icon: 'people',
            title: 'News',
            description: 'Get the latest from your friends list, and share your achievements and hot tips!',
            link: {
              title: 'Explore',
            },
            type: 'community',
          },
        ],
      },

      de: {
        title: 'Chatten',
        blocks: [
          {
            icon: 'smile',
            title: 'Freunde finden',
            description: 'Neue Freunde finden und gemeinsam spielen',
          },
          {
            icon: 'speech-bubble',
            title: 'Chats erstellen',
            description: 'Tritt Chats bei und erstelle neue',
          },
          {
            icon: 'people',
            title: 'Folge <br class="br-none">den News',
            description: 'Erfahre immer die neuesten News deiner Freunde, tausche Meinungen, Tipps und Tricks mit der Community aus und teile Siege.',
            link: {
              title: 'Mehr',
            },
            type: 'community',
          },
        ],
      },

      fr: {
        title: 'Discutez',
        blocks: [
          {
            icon: 'smile',
            title: 'Rencontrez des amis',
            description: 'Faites-vous de nouveaux amis et jouez ensemble',
          },
          {
            icon: 'speech-bubble',
            title: 'Créez des fils de discussion',
            description: 'Rejoignez des discussions et créez-en de nouvelles',
          },
          {
            icon: 'people',
            title: 'Suivez <br class="br-none">les actualités',
            description: 'Suivez les actus de vos amis, partagez vos conseils, avis et astuces, ainsi que vos victoires avec la communauté',
            link: {
              title: 'Accéder',
            },
            type: 'community',
          },
        ],
      },

      es: {
        title: 'Hablar',
        blocks: [
          {
            icon: 'smile',
            title: 'Haz amigos',
            description: 'Haz amigos y jugad juntos',
          },
          {
            icon: 'speech-bubble',
            title: 'Crea chats',
            description: 'Únete a chats y crea los que quieras',
          },
          {
            icon: 'people',
            title: 'Sigue <br class="br-none">las noticias',
            description: 'Estate al corriente de las novedades de tus amigos, comparte opiniones, consejos trucos y victorias en la comunidad',
            link: {
              title: 'Ir Tienda',
            },
            type: 'community',
          },
        ],
      },

      tr: {
        title: 'Konuş',
        blocks: [
          {
            icon: 'smile',
            title: 'Arkadaş edin',
            description: 'Yeni arkadaşlar edin ve birlikte oyna',
          },
          {
            icon: 'speech-bubble',
            title: 'Sohbet Oluştur',
            description: 'Sohbetlere katıl ve yenilerini oluştur',
          },
          {
            icon: 'people',
            title: 'Takip et <br class="br-none">Haberler',
            description: 'Arkadaşlarının haberlerini takip et ve toplulukta fikirleri, ipuçlarını, numaraları ve galibiyetleri paylaş',
            link: {
              title: 'Git',
            },
            type: 'community',
          },
        ],
      },

      pl: {
        title: 'Rozmawiaj',
        blocks: [
          {
            icon: 'smile',
            title: 'Poznawaj znajomych',
            description: 'Poznawaj nowych znajomych i grajcie razem',
          },
          {
            icon: 'speech-bubble',
            title: 'Twórz czaty',
            description: 'Dołączaj do czatów i twórz nowe',
          },
          {
            icon: 'people',
            title: 'Śledź <br class="br-none">nowości',
            description: 'Bądź na bieżąco z wiadomościami od znajomych, dziel się opiniami, wskazówkami i sztuczkami oraz zwycięstwami w społeczności',
            link: {
              title: 'Idź',
            },
            type: 'community',
          },
        ],
      },

      ar: {
        title: 'تواصل',
        blocks: [
          {
            icon: 'smile',
            title: 'البحث عن أصدقاء',
            description: 'قابل أشخاصًا جددًّا والعبوا معًا',
          },
          {
            icon: 'speech-bubble',
            title: 'إنشاء دردشات',
            description: 'تأكد من مزامنة فرقتك. أنشئ الدردشات أو انضم إليها مع الأصدقاء!',
          },
          {
            icon: 'people',
            title: 'الأخبار',
            description: 'احصل على آخر الأخبار من قائمة أصدقائك، وشارك إنجازاتك والنصائح المفيدة!',
            link: {
              title: 'استكشاف',
            },
            type: 'community',
          },
        ],
      },

    },
  },
  computed: {
    links() {
      return {
        dating: '',
        chat: '',
        community: 'https://community.vkplay.ru/community/',
      };
    },
  },
};

</script>
